import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { ShippingAddressAddPage } from 'src/app/modals/shipping-address-add/shipping-address-add.page';

const routes: Routes = [
  {
    path: '',
    component: ShippingAddressAddPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ShippingAddressAddPage]
})
export class ShippingAddressAddPageModule {}
